import type { IResponsiblePropertyManager } from './IResponsiblePropertyManager';

export class ResponsiblePropertyManager implements IResponsiblePropertyManager {
    epost: IResponsiblePropertyManager['epost'];
    kundenummer: IResponsiblePropertyManager['kundenummer'];
    navn: IResponsiblePropertyManager['navn'];
    soContractId: IResponsiblePropertyManager['soContractId'];

    public static empty() {
        return ResponsiblePropertyManager.parseObject({
            epost: '',
            kundenummer: '',
            navn: '',
            soContractId: 0,
        });
    }

    constructor(props: IResponsiblePropertyManager) {
        Object.assign(this, props);
    }

    public static parseObject(
        obj: IResponsiblePropertyManager,
    ): ResponsiblePropertyManager {
        try {
            return new ResponsiblePropertyManager(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Contract Registration object : ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }
}
